import { api } from 'utils';

import {
  FetchGlobalApprovalsApiResponse,
  GlobalApprovalsParams,
} from './GlobalApprovals.types';

export function fetchGlobalApprovalsApi({ queryKey }: any) {
  const [, , params] = queryKey as [string, string, GlobalApprovalsParams];

  return api().get<FetchGlobalApprovalsApiResponse>(
    '/endorsement/health-claims/approvals',
    {
      params: {
        // Sent only when set, so an empty box is no filter rather than a
        // filter on the empty string.
        search: params.search || undefined,
        status: params.status || undefined,
        type: params.type || undefined,
        startDate: params.startDate || undefined,
        endDate: params.endDate || undefined,
        first: params.first,
        rows: params.rows,
      },
    }
  );
}
